module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikdyb3VwIDIzODA0MiI+CjxwYXRoIGlkPSJWZWN0b3IgNDYiIGQ9Ik0yLjY3NzIyIDguMjA4NDVMNi44OTgxNyAxMy44ODE1TDE0LjAwOTggMy4zMDIwNiIgc3Ryb2tlPSIjMDA3OEE3IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/icons/lili-blue-checkmark.svg
// module id = Wcw/
// module chunks = 27